var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "form",
    {
      staticClass: "newsletter-form",
      attrs: { action: "" },
      on: {
        submit: function ($event) {
          $event.preventDefault()
          return _vm.formSubmit()
        },
      },
    },
    [
      _vm.loading
        ? _c("div", { staticClass: "loader-wrap" }, [_vm._m(0)])
        : _vm._e(),
      _vm._v(" "),
      !_vm.loading && _vm.showForm
        ? _c("div", [
            _c("div", { staticClass: "form-item" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.form.taaf,
                    expression: "form.taaf",
                  },
                ],
                staticClass: "taaf",
                attrs: {
                  type: "checkbox",
                  id: _vm.monthlyId,
                  name: _vm.monthlyId,
                },
                domProps: {
                  checked: Array.isArray(_vm.form.taaf)
                    ? _vm._i(_vm.form.taaf, null) > -1
                    : _vm.form.taaf,
                },
                on: {
                  change: function ($event) {
                    var $$a = _vm.form.taaf,
                      $$el = $event.target,
                      $$c = $$el.checked ? true : false
                    if (Array.isArray($$a)) {
                      var $$v = null,
                        $$i = _vm._i($$a, $$v)
                      if ($$el.checked) {
                        $$i < 0 && _vm.$set(_vm.form, "taaf", $$a.concat([$$v]))
                      } else {
                        $$i > -1 &&
                          _vm.$set(
                            _vm.form,
                            "taaf",
                            $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                          )
                      }
                    } else {
                      _vm.$set(_vm.form, "taaf", $$c)
                    }
                  },
                },
              }),
              _vm._v(" "),
              _c(
                "label",
                { attrs: { for: _vm.monthlyId } },
                [_vm._t("labelMonth")],
                2
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-item email" }, [
              _c("span", {
                staticClass: "icon-arrow-right",
                on: {
                  click: function ($event) {
                    return _vm.formSubmit()
                  },
                },
              }),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.form.email,
                    expression: "form.email",
                  },
                ],
                attrs: {
                  type: "email",
                  name: _vm.emailId,
                  id: _vm.emailId,
                  placeholder: "Votre e-mail",
                },
                domProps: { value: _vm.form.email },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(_vm.form, "email", $event.target.value)
                  },
                },
              }),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.confirmMessage
        ? _c("div", { staticClass: "confirm-message" }, [
            _c("p", { domProps: { innerHTML: _vm._s(_vm.confirmMessage) } }),
          ])
        : _vm._e(),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "lds-ring" }, [
      _c("div"),
      _vm._v(" "),
      _c("div"),
      _vm._v(" "),
      _c("div"),
      _vm._v(" "),
      _c("div"),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }